<div class="price-planner-shell" *ngIf="!dismissed">
  <article class="price-planner-card" *ngIf="!loading; else loadingState">
    <header class="price-planner-card__header">
      <div class="price-planner-card__title-block">
        <h3 class="price-planner-card__title" [style.text-align]="titleAlignment">
          {{ widgetConfig?.title || 'Price Planner' }}
        </h3>
        <p class="price-planner-card__subtitle" *ngIf="widgetConfig?.subtitle">{{ widgetConfig?.subtitle }}</p>
      </div>

      <button
        type="button"
        class="price-planner-card__close"
        *ngIf="showClose"
        aria-label="Close planner"
        (click)="dismiss()"
      >
        ×
      </button>
    </header>

    <div class="price-planner-card__content">
      <div class="price-planner-card__error" *ngIf="errorMessage">{{ errorMessage }}</div>

      <section class="planner-sliders" *ngIf="sliderConfigs.length > 0">
        <div class="planner-slider" *ngFor="let slider of sliderConfigs">
          <div class="planner-slider__top">
            <label class="planner-slider__label">{{ slider.label }}</label>
            <div class="planner-slider__value">{{ getSliderDisplayValue(slider) }}</div>
          </div>

          <mat-slider
            class="planner-slider__control"
            [min]="slider.min ?? 0"
            [max]="slider.max ?? 100"
            [step]="slider.step ?? 1"
            [disabled]="slider.editable === false"
          >
            <input
              matSliderThumb
              [ngModel]="formState[slider.key]"
              (ngModelChange)="onSliderChange(slider, $event)"
            />
          </mat-slider>

          <div class="planner-slider__limits">
            <span>{{ getSliderMinLabel(slider) }}</span>
            <span>{{ getSliderMaxLabel(slider) }}</span>
          </div>

          <p class="planner-slider__helper" *ngIf="slider.helperText">{{ slider.helperText }}</p>
        </div>
      </section>

      <section class="planner-fields" *ngIf="fieldConfigs.length > 0">
        <div class="planner-field" *ngFor="let field of fieldConfigs">
          <label class="planner-field__label">{{ field.label }}</label>

          <div class="planner-field__control" [class.readonly]="field.editable === false">
            <span class="planner-field__prefix" *ngIf="field.prefix">{{ field.prefix }}</span>
            <input
              *ngIf="field.editable !== false; else readonlyField"
              class="planner-field__input"
              [type]="getFieldInputType(field)"
              [placeholder]="field.placeholder || ''"
              [ngModel]="getEditableFieldValue(field)"
              (ngModelChange)="onFieldChange(field, $event)"
            />
            <ng-template #readonlyField>
              <div class="planner-field__readonly">{{ getFieldDisplayValue(field) }}</div>
            </ng-template>
            <span class="planner-field__suffix" *ngIf="field.suffix">{{ field.suffix }}</span>
          </div>

          <p class="planner-field__helper" *ngIf="field.helperText">{{ field.helperText }}</p>
        </div>
      </section>

      <section class="planner-results" *ngIf="resultRows.length > 0">
        <h4 class="planner-results__title">Calculated Results</h4>

        <div class="planner-results__row" *ngFor="let row of resultRows">
          <span class="planner-results__label">{{ row.label }}</span>
          <span class="planner-results__value" [ngStyle]="getResultStyles(row)">
            {{ getResultValue(row) }}
          </span>
        </div>
      </section>

      <div class="planner-messages" *ngIf="submitMessage || submitErrorMessage">
        <div class="planner-messages__success" *ngIf="submitMessage">{{ submitMessage }}</div>
        <div class="planner-messages__error" *ngIf="submitErrorMessage">{{ submitErrorMessage }}</div>
      </div>

      <div class="planner-actions">
        <button
          type="button"
          class="planner-actions__button"
          [disabled]="submitting"
          [ngStyle]="getActionButtonStyles()"
          (click)="submitPlanner()"
        >
          {{ submitting ? 'Applying...' : buttonLabel }}
        </button>
      </div>
    </div>
  </article>

  <ng-template #loadingState>
    <article class="price-planner-card price-planner-card--loading">
      <div class="price-planner-card__loading">Loading planner...</div>
    </article>
  </ng-template>
</div>
